var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-div d-flex justify-center align-center"},[_vm._m(0),_c('v-card',{staticClass:"pa-4",attrs:{"width":"500","height":"100%","outlined":_vm.$vuetify.theme.dark,"rounded":"xl"}},[_c('v-card-text',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"blur"})])
}]

export { render, staticRenderFns }